import { Button } from './ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'
import { Badge } from './ui/badge'
import { Checkbox } from './ui/checkbox'
import CarFilter, { TireSizeSelection } from './carfilter'
interface ProductFiltersProps {
  widthOptions: string[]
  ProfileOptions: string[],
  rOptions: string[],
  BrandOptions: string[],
  selectedCategory: string,
  selectedSeason: string,
  selectedThorn: string,
  onThornChange: (thorn: string) => void
  onSeasonChange: (season: string) => void
  selectedBrands: string[]
  onBrandChange: (brands: string[]) => void
  selectedWidth: string
  onWidthChange: (width: string) => void
  selectedHeight: string
  onHeightChange: (height: string) => void
  selectedRadius: string
  onRadiusChange: (radius: string) => void
  onTireSizeSelect?: (size: TireSizeSelection | null) => void
}
 const handleTireSizeSelect = (size: TireSizeSelection | null) => {
    if (!size) {
      onWidthChange('')
      onHeightChange('')
      onRadiusChange('')
      return
    }

    onWidthChange(size.width)
    onHeightChange(size.height)
    onRadiusChange(size.diameter)
  }
export function ProductFilters({
  widthOptions,
  ProfileOptions,
  rOptions,
  BrandOptions,
  selectedCategory,
  selectedThorn,
  selectedSeason,
  onThornChange,
  onSeasonChange,
  selectedBrands,
  onBrandChange,
  selectedWidth,
  onWidthChange,
  selectedHeight,
  onHeightChange,
  selectedRadius,
  onRadiusChange,
  onTireSizeSelect,
}: ProductFiltersProps) {
  const seasonlist = [['all','Все'], ['s','Лето'], ['w','Зима']]
  const thorn = [['all','Все'], ['yes','Шипы'], ['no','Без шипов']]

  const handleBrandToggle = (brand: string) => {
    const updatedBrands = selectedBrands.includes(brand)
      ? selectedBrands.filter(b => b !== brand)
      : [...selectedBrands, brand]
    onBrandChange(updatedBrands)
  }

  const clearAllBrands = () => {
    onBrandChange([])
  }

 
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
    
      <h3 className="font-semibold mb-4">Подбор по параметрам</h3>
      
      {/* Category buttons */}
      <div className="mb-6">
        <h4 className="text-sm font-medium mb-3 text-gray-700">Сезонность</h4>
        <div className="flex flex-wrap gap-2">
          {seasonlist.map((season) => (
            <Button
              key={season[0]}
              variant={selectedSeason === season[0]||(selectedSeason==""&&season[0]=="all") ? "default" : "outline"}
              size="sm"
              onClick={() => onSeasonChange(season[0])}
              className="text-xs"
            >
              {season[1]}
            </Button>
          ))}
        </div>
        {selectedSeason === "w" && ( 
        <div className='flex flex-wrap gap-2 ${classes[selectedSeason]}'>
        {thorn.map((thorn) => (
            <Button
              key={thorn[0]}
              variant={selectedThorn === thorn[0]||(selectedThorn==""&&thorn[0]=="all") ? "default" : "outline"}
              size="sm"
              onClick={() => onThornChange(thorn[0])}
              className="text-xs"
            >
              {thorn[1]}
            </Button>
          ))}
        </div>
        )}
      </div>
      

      {/* Size filters */}
      <div className="mb-6">
        <h4 className="text-sm font-medium mb-3 text-gray-700">Размеры</h4>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="text-sm font-medium mb-2 block text-gray-700">Ширина (мм)</label>
            <Select value={selectedWidth} onValueChange={onWidthChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {widthOptions.map((width) => (
                  <SelectItem key={width} value={width}>
                    {width}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <label className="text-sm font-medium mb-2 block text-gray-700">Профиль (%)</label>
            <Select value={selectedHeight} onValueChange={onHeightChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {ProfileOptions.map((height) => (
                  <SelectItem key={height} value={height}>
                    {height}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <label className="text-sm font-medium mb-2 block text-gray-700">Диаметр (inches)</label>
            <Select value={selectedRadius} onValueChange={onRadiusChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {rOptions.map((radius) => (
                  <SelectItem key={radius} value={radius}>
                    {radius}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-medium text-gray-700">Бренд</h4>
          {selectedBrands.length > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={clearAllBrands}
              className="text-xs text-[#ed8510] hover:text-[#d97706] hover:bg-[#fef3e2]"
            >
              Очистить
            </Button>
          )}
        </div>
        <div className="space-y-3 max-h-48 overflow-y-auto">
           {BrandOptions.map((brand) => (
            <div key={brand} className="flex items-center space-x-2">
              <Checkbox
                id={`brand-${brand}`}
                checked={selectedBrands.includes(brand)}
                onCheckedChange={() => handleBrandToggle(brand)}
                className="data-[state=checked]:bg-[#ed8510] data-[state=checked]:border-[#ed8510]"
              />
              <label
                htmlFor={`brand-${brand}`}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
              >
                {brand}
              </label>
            </div>
          ))}
        </div>
      </div>
      {/* Active filters */}
      <div className="flex flex-wrap gap-2">
        {selectedCategory !== 'all' && (
          <Badge variant="secondary" className="cursor-pointer" onClick={() => onSeasonChange('all')}>
            {selectedCategory} ×
          </Badge>
        )}
        {selectedBrands.map((brand) => (
          <Badge 
            key={brand}
            variant="secondary" 
            className="cursor-pointer" 
            onClick={() => handleBrandToggle(brand)}
          >
            {brand} ×
          </Badge>
        ))}
        {selectedWidth !== 'All Widths' && (
          <Badge variant="secondary" className="cursor-pointer" onClick={() => onWidthChange('All Widths')}>
            Ширина: {selectedWidth}mm ×
          </Badge>
        )}
        {selectedHeight !== 'All Heights' && (
          <Badge variant="secondary" className="cursor-pointer" onClick={() => onHeightChange('All Heights')}>
            Профиль: {selectedHeight}% ×
          </Badge>
        )}
        {selectedRadius !== 'All Sizes' && (
          <Badge variant="secondary" className="cursor-pointer" onClick={() => onRadiusChange('All Sizes')}>
            Диаметр{selectedRadius} ×
          </Badge>
        )}
      </div>
        <h3 className="font-semibold mb-4">Подбор по авто</h3>
       <div className="mb-6">
          <CarFilter
          onTireSizeSelect={onTireSizeSelect}
          currentWidth={selectedWidth}
          currentProfile={selectedHeight}
          currentDiameter={selectedRadius}
        />
      </div>
    </div>
  )
}

function onWidthChange(arg0: string) {
  throw new Error('Function not implemented.')
}
function onHeightChange(arg0: string) {
  throw new Error('Function not implemented.')
}

function onRadiusChange(arg0: string) {
  throw new Error('Function not implemented.')
}

